import axios from "axios";
import config from "@/rsaConfig.js";
import tokenUtil from "../util/tokenUtil.js";

let qs = require("qs");
import {Toast} from "vant";
import store from "../store.js";
import {getPublicAndPrivateKey} from "../util/PublicAndPrivateKey.js";
//获取加密算法
import RsaUtil from "../util/RsaUtil.js";

let refreshTokenState = 0;
let locked10037 = 0;
import router from "../router";
let noKeyNum = 0;
/**
 * 封装的axios和ajax 一般用axios足够。如果有jsonp需求可以使用zport的ajax;
 */
export default async ({
                          apiUrl = "",
                          params = {},
                          type = "GET",
                          apiCode = "", //license的值
                          isSendRsa = false, //请求参数是否加密
                          isUcode = false, //是否需要登录
                          contentType = "application/json;charset=utf-8" //请求头
                      }) => {
    type = type.toUpperCase();
    return new Promise((resolve, reject) => {
        let {publicKey, privateKey, signKey, clientKey} = getPublicAndPrivateKey();
        // console.log('publicKey, privateKey, signKey, clientKey', publicKey, privateKey, signKey, clientKey)

        const timestamp = new Date().getTime() + "";
        const rsa = new RsaUtil(publicKey, privateKey, signKey, timestamp);

        let rsaParams;
        let rsaObj = {};
        console.log("打印未加密前参数", params, apiUrl);
        // console.log("打印未加密前参数", JSON.stringify(params));
        //请求参数是否加密
        if (isSendRsa) {
            console.log('noKeyNum++',noKeyNum)
            if (noKeyNum > 0) {
                return false
            }
            if (!publicKey || !privateKey || !signKey) {
                noKeyNum++
                setTimeout(() => {
                    noKeyNum = 0;
                    console.log('noKeyNum',noKeyNum)
                    window.location.reload();
                }, 5 * 1000);
                return false
            }

            rsaObj = rsa.encryptLong(Base64.encode(JSON.stringify(params)));
            rsaParams = qs.stringify({
                    data: rsaObj.encryptStr, noncestr: rsaObj.nonceStr, timestamp: timestamp
                }, {arrayFormat: "repeat"}
            );
            if (contentType === "application/json;charset=utf-8") {
                rsaParams = {data: rsaObj.encryptStr, noncestr: rsaObj.nonceStr, timestamp: timestamp};
            }
        }
        let isLoginUrl = false;
        if (apiUrl.indexOf("/oauth/token") > -1) {
            isLoginUrl = true;
        }
        axios({
            method: type,
            url: apiUrl,
            headers: {
                Authorization: isLoginUrl === true ? "Basic " + Base64.encode(`${clientKey}`) : tokenUtil.getToken(),
                "Content-Type": contentType,
                license: Base64.encode(`${config.clientId}:${apiCode}:${isUcode === true ? tokenUtil.getUcode() : "anyone"}`),
                "X-Ca-Proxy-Signature": (rsaObj.md5Str && rsaObj.md5Str.toUpperCase()) || ""
            },
            data: type === "POST" ? rsaParams || params : "",
            params: type === "GET" ? rsaParams || params : ""
            // timeout: appConfigs.timeout,
            /* 开启跨域cookie携带 */
            // credentials : true,
            // emulateHTTP: true,
            // emulateJSON:true
        }).then(res => {
                // 认证：
                // 10039,"LICENSE解析失败"
                // 10023,"LICENSE无效，不能为空"
                // 10026,"LICENSE中携带了无效的客户端ID"
                // 10028,"LICENSE中携带了无效的接口编号"
                // 10035,"TOKEN解析失败，无效的TOKEN"------前端传递的token无效，为空，或者无法识别
                // 10024,"无权访问该资源，权限放行认证失败"
                // 10038,"当前账号已经退出，请重新登录" ---------缓存中没有了token
                // 10037,"您的账号已经在其它设备上登录"----------缓存中的token和前端传递的token不一样
                // 10029,"获取认证客户端的授权信息失败"----------客户端中没有携带授权信息，无权访问该接口
                // 10030,"非法请求，禁止游客模式请求" -----------游客访问了授权接口
                // 10031,"获取操作权限失败"-------------获取当前登录用户的权限失败---重试
                // 10040,"权限认证异常，请稍后重试" ---------匹配权限的时候出现错误--重试
                // 10032,"您无权访问该资源"---------当前登录用户没有权限访问该接口
                // 10041,"REFRESH TOKEN 过期，请重新登录
                // 10042 无效token
                // clearTimeout(setovertime);
                // console.log("res");
                // console.log('vueRequest的login_source',store.state.login_source);
                res = res.data;
                //10038 当前账号已经退出 请重新登录 跳转到登录页
                if (res.code === 10038) {
                    //不存在返回登录
                    store.commit("changeLogin", false);
                    store.commit("CHANGE_ACCOUNT", true);
                    tokenUtil.clearToken();
                    // let url = window.location.href.split("#")[0];
                    // window.location.href = `${url}#/login`;
                    return false
                }
                //刷新token  10035：token解析失败无效的token  10039：license解析失败  10023：license为空  10026:license携带了无效的客户端id  10028：license携带了无效的接口编号
                if (res.code === 10035 || res.code === 10039 || res.code === 10042 ||
                    res.code === 10023 || res.code === 10026 || res.code === 10028) {
                    // Toast.clear();
                    //refreshToken 存在的情况下
                    if (tokenUtil.getRefreshToken() !== undefined) {
                        if (refreshTokenState === 0) {
                            refreshTokenState++;
                            tokenUtil.refreshToken();
                        }
                    } else {
                        store.commit("changeLogin", false);
                        store.commit("CHANGE_ACCOUNT", true);
                        tokenUtil.clearToken();
                        // let url = window.location.href.split("#")[0];
                        // window.location.href = `${url}#/login`;
                        reject(res);
                    }
                    return;
                }
                //账号异常登录情况  10037:您的账号已经在其他设备上登录
                if (res.code === 10037 || res.code === 10036) {
                    Toast({
                        message: "您的账号已经在其它设备上登录",
                        duration: 2000
                    });
                    // Toast.clear();

                    /*let url = window.location.href.split("#")[0];
                    window.location.href = `${url}#/login`;*/
                    /*router.push({
                        name: 'Login'
                    });*/
                    console.log('locked10037',locked10037);
                    console.log('store.state.isAccount',store.state.isAccount)
                    if (locked10037 === 0) {
                        locked10037++
                        //账号被挤，移除登录状态
                        store.commit("changeLogin", false);
                        store.commit("CHANGE_ACCOUNT", true);
                        console.log('store.state.isAccount',store.state.isAccount)
                        tokenUtil.clearToken();
                    }
                    return;
                }
                //刷新token过期
                if (res.code === 10041) {
                    store.commit("changeLogin", false);
                    store.commit("CHANGE_ACCOUNT", true);
                    tokenUtil.clearToken();
                    // let url = window.location.href.split("#")[0];
                    // window.location.href = `${url}#/login`;
                    return;
                }
                //无权访问
                if (res.code === 10032 || res.code === 10024 || res.code === 10030 ||
                    res.code === 10029 || res.code === 10031 || res.code === 10040) {
                    Toast({
                        message: "无权访问",
                        duration: 2000
                    });
                    store.commit("changeLogin", false);
                    store.commit("CHANGE_ACCOUNT", true);
                    return;
                }
                locked10037 = 0;
                store.commit("CHANGE_ACCOUNT", false);
                if (res.de) {
                    // 需要解密
                    if (!res.data) {
                        resolve(res);
                        return false;
                    }
                    let decryptData = rsa.decryptLong(res.data);
                    res.data = JSON.parse(Base64.decode(decryptData));

                    if (res.vsg) {
                        // 需要验签
                        let sign = res.sign;
                        let signature = rsa.getServiceSignature(res.data, res.noncestr, res.timestamp);
                        if (sign === signature) {
                            resolve(res);
                        } else {
                            // console.log("验签失败，数据可能存在错误...");
                            resolve(res);
                        }
                    } else {
                        // 不验签
                        resolve(res);
                    }
                } else {
                    // 不需要解密
                    if (res.vsg) {
                        // 需要验签
                        let sign = res.sign;
                        let signature = rsa.getServiceSignature(res.data, res.noncestr, res.timestamp);
                        if (sign === signature) {
                            resolve(res);
                        } else {
                            console.log("验签失败，数据可能存在错误...");
                        }
                    } else {
                        // 不验签
                        resolve(res);
                    }
                }
            })
            .catch(err => {
                console.log("接口请求错误error", err);
                let statu = err.status || err.response.status;
                if (statu == 504 || statu == 500) {
                    Toast({
                        message: "网络异常，请稍后再试",
                        duration: 2000
                    });
                    // resolve(err);
                } else {
                    let errCode = err.response.data || '';
                    const errMessage = err.response.data && err.response.data.message;
                    if (errCode.code == -1) {
                        Toast({
                            message: errMessage || "网络异常，请稍后再试",
                        });
                        return false
                    }
                    Toast({
                        message: "网络异常，请稍后再试",
                        duration: 2000
                    });
                }
                reject(err);
            });
    });
};



// WEBPACK FOOTER //
// ./src/modle/vueAiRequest.js